export default "__VITE_ASSET__B0YLUA6b__"